"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=606%3A416))
 * @trackcomponent
 * @lastsynced 2023-11-30T13:48:41.843Z
 */
export const ExclamationSolid = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M0 12C0 15.1826 1.26428 18.2348 3.51471 20.4853C5.76515 22.7357 8.81738 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.81738 22.7357 5.76515 20.4853 3.51471C18.2348 1.26428 15.1826 0 12 0C8.81738 0 5.76515 1.26428 3.51471 3.51471C1.26428 5.76515 0 8.81738 0 12ZM11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V12.5C13 13.0523 12.5523 13.5 12 13.5C11.4477 13.5 11 13.0523 11 12.5V6ZM10.9393 18.0606C10.658 17.7794 10.5 17.3979 10.5 16.9999C10.5 16.6021 10.658 16.2206 10.9393 15.9392C11.2205 15.658 11.6022 15.5 12 15.5C12.3978 15.5 12.7793 15.658 13.0607 15.9392C13.342 16.2206 13.5 16.6021 13.5 16.9999C13.5 17.3979 13.342 17.7794 13.0607 18.0606C12.7793 18.342 12.3978 18.5 12 18.5C11.6022 18.5 11.2205 18.342 10.9393 18.0606Z"
    fill="currentColor"
  />,
  "ExclamationSolid",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
